module.exports = "/_next/static/images/4f7eefb8763f95bb026553bd112e56d3-box.svg";